import { Component, OnInit } from '@angular/core';
import { SuperadminService } from 'src/app/services/superadmin/superadmin.service';
import { GlobalHelper } from 'src/app/services/Common/global.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { LookupService } from 'src/app/services/Common/lookup.service';

@Component({
  selector: 'app-transactionalaccount',
  templateUrl: './transactionalaccount.component.html',
  styleUrls: ['./transactionalaccount.component.css']
})
export class TransactionalaccountComponent implements OnInit {

  AccountList: any;
  SchoolList: any;
  APIList: any;
  BranchList: any;

  Submitted: boolean = false;
  

  constructor(private superadminservice: SuperadminService, private lookupservice: LookupService,
    public globalHelper: GlobalHelper, private spinnerService: Ng4LoadingSpinnerService) { }


  SearchModel = {
    SchoolID: 0
  }


  GetAccount() {
    this.spinnerService.show();
    this.superadminservice.GetAccount(JSON.stringify(this.SearchModel)).subscribe((response: any) => {
      this.AccountList = response.AccountList;
      this.spinnerService.hide();

    });
  };

  AccountModel = {
    AccountID: 0,
    BranchID: 0,
    SchoolID: 0,
    APIID: 0,
    UserID: '',
    Pasword: '',
    Sender: '',
    Keys: '',
    IsActive:true,
    HeaderID:"",
    PrincipalEntity:"",
  };

  ClearTranAccModel() {
    this.AccountModel.AccountID = 0;
    this.AccountModel.SchoolID = 0;
    this.AccountModel.BranchID = 0;
    this.AccountModel.APIID = 0;
    this.AccountModel.UserID = '';
    this.AccountModel.Pasword = '';
    this.AccountModel.Sender = '';
    this.AccountModel.Keys = '';
    this.AccountModel.HeaderID = '';
    this.AccountModel.PrincipalEntity = '';
    this.Submitted = false;
  }


  ValidationDropdown() {
    return this.AccountModel.SchoolID == 0 || this.AccountModel.BranchID == 0 || this.AccountModel.APIID == 0;
  }

  SaveAccount(valid) {
    this.Submitted = true;
    if (valid && !this.ValidationDropdown()) {
      this.spinnerService.show();
      this.superadminservice.SaveAccount(JSON.stringify(this.AccountModel)).subscribe((data: any) => {
        if (data.webResponse.Status && this.AccountModel.AccountID == 0) {
          this.ClearTranAccModel();
        }
        if (data.webResponse.Status) {
          this.GetAccount();
        }

        this.spinnerService.hide();
        this.globalHelper.CheckActionStatus(data)
        this.Submitted = false;
      });
    }
  };



  TranAccEdit(obj) {

    this.AccountModel.AccountID = obj.AccountID;
    this.AccountModel.SchoolID = obj.SchoolID;
    this.GetBranch();
    this.AccountModel.BranchID = obj.BranchID;
    this.AccountModel.APIID = obj.APIID;
    this.AccountModel.UserID = obj.UserID;
    this.AccountModel.Pasword = obj.Pasword;
    this.AccountModel.Sender = obj.Sender;
    this.AccountModel.Keys = obj.Keys;
    this.AccountModel.PrincipalEntity = obj.PrincipalEntity;
    this.AccountModel.HeaderID = obj.HeaderID;
  };


  TranAccMarkActive(obj) {
    this.AccountModel.AccountID = obj.AccountID;
    this.AccountModel.IsActive = obj.IsActive == true ? false : true;
    this.spinnerService.show();
    this.superadminservice.TranAccMarkActive(JSON.stringify(this.AccountModel)).subscribe((response: any) => {
      this.spinnerService.hide();
      this.GetAccount();
      this.globalHelper.CheckActionStatus(response);

    });
  }


  ngOnInit() {   
    this.BindSchool();
    this.GetAPI();
    this.GetAccount();
  }



  BindSchool() {
    this.lookupservice.GetLookupsList('School', '').subscribe((data: any) => {
      this.SchoolList = data.LookupItems;

    });
  };

  GetAPI() {
    this.lookupservice.GetLookupsList('API', '').subscribe((data: any) => {
      this.APIList = data.LookupItems;
    });
  };

  GetBranch() {

    var Itembo = {
      'ItemId': this.AccountModel.SchoolID
    }
    this.lookupservice.GetLookupsList('BranchBySchool', JSON.stringify(Itembo)).subscribe((data: any) => {
      this.BranchList = data.LookupItems;
    });
  };

}



